var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditSquareDisabled = function SvgEditSquareDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m811.146 420-171-168 100-100q17-17 42.31-17 25.312 0 42.69 18l84 85q17 18 17 42.472t-18 41.528z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m562.079 592.242 42.851 42.032 206.203-214.29-41.992-41.992zM370.43 521.742l-32.266 32.266v170h170l33.906-34.024-42.851-42.03-16.055 16.054h-85v-86.016l14.727-14.648zM431.88 460.988l42.461 41.601 208.823-208.581-43.008-41.992zM758.033 788.08l60.073 60.366.058-352.446-60 60z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M114.61 265.57c-10.055 11.294-16.446 23.793-16.446 38.438v600c0 16 5.969 29.992 17.969 41.992s26.031 18.008 42.031 18.008h600c16 0 29.992-6.008 41.992-18.008 1.733-1.732 1.135-4.239 2.617-6.055l-44.609-43.71v7.773h-600V308.227zM275.835 303.246l227.33.762 60-60-346.658.078z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m56.648 207.056 796.235 799.184",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 60
    }
  }));
};
export default SvgEditSquareDisabled;